<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-dialog
      v-model="confirm_dialog_vehicle"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Confirmación
        </v-card-title>
        <v-card-text>
          ¿Desea desasociar el vehículo de la vivienda?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="cancel_delete_vehicle()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="delete_asoc_vehicle()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirm_dialog"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Confirmación
        </v-card-title>
        <v-card-text>
          ¿Desea desasociar al residente de la vivienda?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="cancel_delete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="delete_asoc()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--
    <v-dialog
      v-model="add_dialog"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Asociar Residente
          <v-progress-linear v-if="sendig_asoc()" :indeterminate="true" height="2">
          </v-progress-linear>
        </v-card-title>
        <v-container grid-list-md>
          <v-form
            ref="residentForm"
            v-model="residentValid"
            lazy-validation
          >
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-combobox
                v-model="residente"
                :items="residentes"
                :loading="residenteIsLoading"
                :search-input.sync="residenteSearch"
                :hide-no-data="!residenteSearch"
                hide-selected
                item-text="fullname"
                item-value="fullname"
                label="Nombres"
                placeholder="Comience a escribir para buscar"
                return-object
                :rules="text_required_rules"
              >
              </v-combobox>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="puedeAutorizar"
            label="Puede Autorizar"
            disabled
          ></v-checkbox>
          <v-radio-group v-model="tipoResidente" row :rules="text_required_rules">
            <v-radio label="Propietario" value="propietario"></v-radio>
            <v-radio label="Propietario Residente" value="propietario_residente"></v-radio>
            <v-radio label="Residente Inquilino" value="residente_inquilino"></v-radio>
          </v-radio-group>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="add_dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="send_resident_form"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    -->
    <v-dialog
      v-model="confirm_deleted_dialog"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Confirmación
        </v-card-title>
        <v-card-text v-if="this.vivienda_info.vivienda_id">
          ¿Está seguro que desea eliminar la vivienda: <span class="font-weight-bold">{{ this.vivienda_info.n_vivienda }}</span>?
        </v-card-text>
        <v-card-text v-else>
          <div class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat"
                 @click="confirm_deleted_dialog = false">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 @click="delete_vivienda_confirm"
                 v-if="this.vivienda_info.vivienda_id"
          >
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 v-else
                 disabled
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container grid-list-md fluid>
      <v-alert
        :value="alert"
        dismissible
        :type="alertType"
      >
        {{ alertMessage }}
      </v-alert>
      <v-layout wrap>
        <v-flex xs12 sm6 md11>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="presearch"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </v-flex>
        <!--
        <v-flex xs12 sm6 md1 class="pt-4">
          <v-btn
            disabled
            @click="dialog = true"
          >
            Agregar
          </v-btn>
        </v-flex>
        -->
      </v-layout>
    </v-container>
    <v-data-table
      :headers="headers"
      v-bind:items="viviendas"
      class="elevatilen-1"
      :loading="is_loading"
      :search="search"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left">{{ props.item.desarrollo }}</td>
          <td class="text-xs-left">{{ props.item.subcondominio }}</td>
          <td class="text-xs-left">{{ props.item.n_vivienda }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td class="text-xs-left">{{ props.item.status_inmobiliaria }}</td>
          <td class="text-xs-left">{{ props.item.telefono }}</td>
          <td class="text-xs-left">{{ props.item.cajones_estacionamiento }}</td>
          <td class="text-xs-left">{{ props.item.num_tags }}</td>
          <td class="text-xs-left">{{ props.item.num_vehiculos }}</td>
          <td class="text-xs-left">
            <v-icon
              small class="mr-2"
              @click.prevent="show_vivienda_info(props.item.id)"
            >
              visibility
            </v-icon>
            <v-icon
              small class="mr-2"
              v-show="editing_btn === true" :disabled="!editing_btn"
              @click.prevent="edit_vivienda_info(props.item.id)">
              edit
            </v-icon>
            <v-icon
              small class="mr-2"
              v-show="delete_btn === true" :disabled="!delete_btn"
              @click="show_delete_vivienda_dialog(props.item.id)"
            >
              delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-container grid-list-md>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close_dialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="send_form">Guardar</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container grid-list-md fluid >
            <v-layout row wrap>
              <v-flex xs10 sm12 md12>
                <v-form
                  ref="form"
                  id="vivienda_form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-layout row wrap>
                    <v-flex xs12 sm2 md2>
                      <v-text-field
                        v-model = "desarrollo"
                        label="Condominio"
                        v-if="this.editing===true"
                        readonly
                      ></v-text-field>
                      <v-text-field
                        v-model="selected_desarrollo"
                        :rules="text_required_rules"
                        label="Condominio"
                        v-else
                        required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <v-text-field
                        v-model = "subcondominio"
                        label="Sub-Condominio"
                        v-if="this.editing===true"
                        readonly
                      ></v-text-field>
                      <v-select
                        v-model="selected_subcondominio"
                        :items="subcondominios"
                        item-text="nombre"
                        :rules="text_required_rules"
                        label="Sub-Condominio"
                        v-else
                        required
                        return-object
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <v-text-field
                        v-model="n_vivienda"
                        :readonly="this.editing===true"
                        :rules="text_required_rules"
                        label="Vivienda"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs10 sm2 md2>
                      <v-text-field
                        v-model = "telefono"
                        :readonly="this.editing_details_btn===false"
                        label="Teléfono"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs10 sm2 md2>
                      <v-text-field
                        v-model = "cajones_estacionamiento"
                        :readonly="this.editing_details_btn===false"
                        label="Cajones Estacionamiento"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs10 sm2 md2>
                      <v-text-field
                        v-model = "num_tags"
                        :readonly="this.editing_details_btn===false"
                        label="Número De Tags"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs10 sm2 md2>
                      <v-text-field
                        v-model = "num_vehiculos"
                        :readonly="this.editing_details_btn===false"
                        label="Número De Vehículos"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <v-select
                        v-model="selected_status"
                        :items="tipos_status"
                        :rules="text_required_rules"
                        :readonly="this.editing_details_btn===false"
                        label="Estatus"
                        required
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <v-select
                        v-model="selected_inmobiliaria_status"
                        :items="tipos_status_inmobiliaria"
                        :rules="text_required_rules"
                        :readonly="this.editing_details_btn===false"
                        label="Estatus Inmobiliaria"
                        required
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap >
                    <v-flex xs12 sm12 md12>
                      Residentes
                      <v-divider></v-divider>
                    </v-flex>
                    <!--
                    <v-flex xs10 sm1 md1>
                      <v-btn
                        color="primary"
                        dark
                        @click="add_dialog = true"
                      >
                        Agregar
                      </v-btn>
                    </v-flex>
                    -->
                  </v-layout>
                  <v-data-table
                    :headers="residente_headers"
                    v-bind:items="residentes_asociados"
                    class="table-residentes"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td class="text-xs-left">{{ props.item.residente.nombres }}</td>
                        <td class="text-xs-left">{{ props.item.residente.apellido_paterno }}</td>
                        <td class="text-xs-left">{{ props.item.residente.apellido_materno }}</td>
                        <td class="text-xs-left">{{ props.item.residente.nds }}</td>
                        <td class="text-xs-left">{{ props.item.residente.emails }}</td>
                        <td class="text-xs-left">{{ props.item.residente.status }}</td>
                        <td v-if="props.item.puede_autorizar" class="text-xs-center">SI</td>
                        <td v-else class="text-xs-center">NO</td>
                        <td v-if="props.item.propietario" class="text-xs-center">SI</td>
                        <td v-else class="text-xs-center">NO</td>
                        <td v-if="props.item.propietario_residente" class="text-xs-center">SI</td>
                        <td v-else class="text-xs-center">NO</td>
                        <td v-if="props.item.residente_inquilino" class="text-xs-center">SI</td>
                        <td v-else class="text-xs-center">NO</td>
                        <td v-if="props.item.residente.censado" class="text-xs-left">
                          {{ props.item.residente.censado_fecha }}
                        </td>
                        <td v-else class="text-xs-center"></td>
                        <td class="text-xs-center">
                          <v-icon
                            small
                            @click="prepare_delete(vivienda_id, props.item.residente_id)"
                          >
                            fa-times
                          </v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <!--
                  <v-layout row wrap >
                    <v-flex xs10 sm12 md12>
                      Vehículos
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex xs10 sm12 md12>
                      <v-data-table
                        :headers="vehiculo_headers"
                        v-bind:items="vivienda_info.vehiculos"
                      >
                        <template v-slot:items="props">
                          <tr>
                            <td class="text-xs-left">{{ props.item.vehiculo.marca }}</td>
                            <td class="text-xs-left">{{ props.item.vehiculo.modelo }}</td>
                            <td class="text-xs-left">{{ props.item.vehiculo.anio }}</td>
                            <td class="text-xs-left">{{ props.item.vehiculo.color }}</td>
                            <td class="text-xs-left">{{ props.item.vehiculo.num_serie }}</td>
                            <td class="text-xs-left">{{ props.item.vehiculo.placas }}</td>
                            <td class="text-xs-left">{{ props.item.vehiculo.validez }}</td>
                            <td class="text-xs-left">
                              <v-btn flat icon @click.stop="carousel_dialog = true"
                                     :disabled="Object.keys(props.item.vehiculo.fotos).length === 0"
                              >
                                <v-icon>collections</v-icon>
                              </v-btn>
                              <div class="text-xs-center">
                                <v-dialog
                                  v-model="carousel_dialog"
                                  max-width="900"
                                >
                                  <v-card>
                                    <v-toolbar dark color="primary">
                                      <v-spacer></v-spacer>
                                      <v-btn dark icon @click="carousel_dialog = false">
                                        <v-icon>close</v-icon>
                                      </v-btn>
                                    </v-toolbar>
                                    <template>
                                      <v-carousel dark hide-delimiters height="600" :cycle="false"
                                      >
                                        <v-carousel-item
                                          v-for="(item,i) in props.item.vehiculo.fotos"
                                          :key="i"
                                        >
                                          <img :src="decode_base64(item.image)"
                                               style="height: 600px; display: block; margin: 0px auto;"
                                          />
                                        </v-carousel-item>
                                      </v-carousel>
                                    </template>
                                  </v-card>
                                </v-dialog>
                              </div>
                            </td>
                            <td class="text-xs-center">
                              <v-icon
                                small
                                @click="prepare_delete_vehicle(vivienda_id, props.item.vehiculo.vehiculo_id)"
                              >
                                fa-times
                              </v-icon>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                  -->
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container grid-list-md>
      <v-dialog v-model="close_resident_info">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close_resident_info = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Detalles del Residente</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container grid-list-md fluid  v-if="this.user_login_role === 'censo' || this.user_login_role === 'admin'">
            <v-layout row wrap class="pb-4">
              <v-flex xs10 sm3 md3>
                <v-text-field
                  label="Nombre(s)"
                  placeholder=""
                  readonly
                  v-model = "resident_info().nombres"
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm3 md3>
                <v-text-field
                  label="Apellido Paterno"
                  placeholder=""
                  readonly
                  v-model = "resident_info().apellido_paterno"
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm3 md3>
                <v-text-field
                  label="Apellido Materno"
                  placeholder=""
                  readonly
                  v-model = "resident_info().apellido_materno"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm1 md1>
                <v-text-field
                  v-model="resident_info().nds"
                  label="NDS"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  v-model="resident_info().dependiente_de"
                  label="Dependiente de"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm1 md1>
                <v-switch readonly v-model="resident_info().tiene_accion" label="Tiene acción:">
                </v-switch>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  readonly=""
                  v-model="resident_info().n_accion"
                  label="# de acción"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  readonly
                  v-model="resident_info().status"
                  label="Estatus"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="resident_info().direccion"
                  label="Dirección"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="resident_info().codigo_postal"
                  label="Código Postal"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="resident_info().estado_civil"
                  label="Estado Civil"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3 v-if="resident_info().fecha_nacimiento === 'None'">
                <v-text-field
                  label="Fecha Nacimiento"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3 v-else>
                <v-text-field
                  v-model="resident_info().fecha_nacimiento"
                  label="Fecha Nacimiento"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3 v-if="resident_info().fecha_ingreso === 'None'">
                <v-text-field
                  label="Fecha Ingreso"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3 v-else>
                <v-text-field
                  v-model="resident_info().fecha_ingreso"
                  label="Fecha Ingreso"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="resident_info().estudia_en"
                  label="Estudia En"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm9 md9>
                <v-text-field
                  v-model="resident_info().notas"
                  label="Notas"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-layout row wrap>
                <v-flex xs12 sm6 md12 class="text-md-left">
                  En caso de emergencia avisar a
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="resident_info().nombre_contacto_emergencia"
                    label="Nombre Completo"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="resident_info().email_contacto_emergencia"
                    label="Correo Electrónico"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="resident_info().telefono_contacto_emergencia"
                    label="Teléfono"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-data-table
                    :headers="contactos_emergencia_headers"
                    v-bind:items="resident_info().contactos_emergencia"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td class="text-xs-left">{{ props.item.nombre_emergencia }}</td>
                        <td class="text-xs-left">{{ props.item.email_emergencia }}</td>
                        <td class="text-xs-left">{{ props.item.telefono_emergencia }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md12 class="text-md-left">
                  Zonas de Interés y Comunicados
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().interes_golf"
                              label="Golf"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().interes_tenis"
                              label="Tenis & Padel"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().interes_natacion"
                              label="Natación"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().interes_gym"
                              label="Gimnasio"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().interes_ludoteca"
                              label="Ludoteca"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().interes_ayb"
                              label="Alimentos & Bebidas"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().interes_torneos"
                              label="Torneos"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().interes_eventos"
                              label="Eventos Sociales & Culturales">
                  </v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().interes_comunicados"
                              label="Comunicados De Interés">
                  </v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 md12 class="text-md-left">
                  Como desea recibir la información
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().medio_gpo_whatsapp"
                              label="Grupos de WhatsApp"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().medio_chat_whatsapp"
                              label="WhatsApp privado">
                  </v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().medio_email" label="Correo Electrónico">
                  </v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().medio_telefono" label="Teléfono">
                  </v-checkbox>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox readonly v-model="resident_info().medio_app" label="Directo en la app">
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-layout>
            Correos Electrónicos
            <v-divider></v-divider>
            <v-data-table
              :headers="email_headers"
              v-bind:items="resident_info().emails"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.tipo }}</td>
                </tr>
              </template>
            </v-data-table>
            Teléfonos
            <v-divider></v-divider>
            <v-data-table
              :headers="telefonos_headers"
              v-bind:items="resident_info().telefonos"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.telefono }}</td>
                  <td class="text-xs-left">{{ props.item.tipo }}</td>
                  <td class="text-xs-left">{{ props.item.nombre }}</td>
                </tr>
              </template>
            </v-data-table>
            Viviendas
            <v-divider></v-divider>
            <v-data-table
              :headers="viviendas_headers"
              v-bind:items="resident_info().viviendas"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.vivienda.desarrollo }}</td>
                  <td class="text-xs-left">{{ props.item.vivienda.subcondominio }}</td>
                  <td class="text-xs-left">{{ props.item.vivienda.n_vivienda }}</td>
                  <td class="text-xs-left">{{ props.item.vivienda.telefono }}</td>
                  <td class="text-xs-left">{{ props.item.vivienda.status }}</td>
                  <td v-if="props.item.puede_autorizar" class="text-xs-left">SI</td>
                  <td v-else class="text-xs-left">NO</td>
                  <td v-if="props.item.propietario" class="text-xs-left">SI</td>
                  <td v-else class="text-xs-left">NO</td>
                  <td v-if="props.item.propietario_residente" class="text-xs-left">SI</td>
                  <td v-else class="text-xs-left">NO</td>
                  <td v-if="props.item.residente_inquilino" class="text-xs-left">SI</td>
                  <td v-else class="text-xs-left">NO</td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
          <v-container grid-list-md fluid v-else-if="this.user_login_role === 'jefe_monitoristas' || this.user_login_role === 'monitoristas' || this.user_login_role === 'atencion_residentes' || this.user_login_role === 'avisos'">
            <v-layout row wrap class="pb-4">
              <v-flex xs10 sm3 md4>
                <v-text-field
                  label="Nombre(s)"
                  placeholder=""
                  readonly
                  v-model = "resident_info().nombres"
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm3 md4>
                <v-text-field
                  label="Apellido Paterno"
                  placeholder=""
                  readonly
                  v-model = "resident_info().apellido_paterno"
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm3 md4>
                <v-text-field
                  label="Apellido Materno"
                  placeholder=""
                  readonly
                  v-model = "resident_info().apellido_materno"
                ></v-text-field>
              </v-flex>
            </v-layout>
            Teléfonos
            <v-divider></v-divider>
            <v-data-table
              :headers="telefonos_headers"
              v-bind:items="resident_info().telefonos"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.telefono }}</td>
                  <td class="text-xs-left">{{ props.item.tipo }}</td>
                  <td class="text-xs-left">{{ props.item.nombre }}</td>
                </tr>
              </template>
            </v-data-table>
            Correos Electrónicos
            <v-divider></v-divider>
            <v-data-table
              :headers="email_headers"
              v-bind:items="resident_info().emails"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.tipo }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-layout row wrap>
              <v-flex xs12 sm6 md12 class="text-md-left">
                En caso de emergencia avisar a
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="resident_info().nombre_contacto_emergencia"
                  label="Nombre Completo"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="resident_info().email_contacto_emergencia"
                  label="Correo Electrónico"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="resident_info().telefono_contacto_emergencia"
                  label="Teléfono"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-data-table
                  :headers="contactos_emergencia_headers"
                  v-bind:items="resident_info().contactos_emergencia"
                >
                  <template v-slot:items="props">
                    <tr>
                      <td class="text-xs-left">{{ props.item.nombre_emergencia }}</td>
                      <td class="text-xs-left">{{ props.item.email_emergencia }}</td>
                      <td class="text-xs-left">{{ props.item.telefono_emergencia }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="infodialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close_info_dialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Detalles de la Vivienda</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container grid-list-md fluid >
            <v-layout row wrap class="pb-4">
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Condominio"
                  placeholder=""
                  readonly
                  v-model = "vivienda_info.desarrollo"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Sub-Condominio"
                  placeholder=""
                  readonly
                  v-model = "vivienda_info.subcondominio"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Vivienda"
                  placeholder=""
                  readonly
                  v-model = "vivienda_info.n_vivienda"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Teléfono"
                  placeholder=""
                  readonly
                  v-model = "vivienda_info.telefono"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Cajones Estacionamiento"
                  placeholder=""
                  readonly
                  v-model = "vivienda_info.cajones_estacionamiento"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Número De Tags"
                  placeholder=""
                  readonly
                  v-model = "vivienda_info.num_tags"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Número De Vehículos"
                  placeholder=""
                  readonly
                  v-model = "vivienda_info.num_vehiculos"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Estatus"
                  placeholder=""
                  readonly
                  v-model = "vivienda_info.status"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Estatus Inmobiliaria"
                  placeholder=""
                  readonly
                  v-model = "vivienda_info.status_inmobiliaria"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap >
              <v-flex xs10 sm12 md12>
                Residentes
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-data-table
              :headers="residente_headers"
              v-bind:items="vivienda_info.residentes"
              class="table-residentes"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">
                    {{ props.item.residente.nombres }}
                  </td>
                  <td class="text-xs-left">{{ props.item.residente.apellido_paterno }}</td>
                  <td class="text-xs-left">{{ props.item.residente.apellido_materno }}</td>
                  <td class="text-xs-left">{{ props.item.residente.nds }}</td>
                  <td class="text-xs-left">{{ props.item.residente.emails }}</td>
                  <td class="text-xs-left">{{ props.item.residente.status }}</td>
                  <td v-if="props.item.puede_autorizar" class="text-xs-center">SI</td>
                  <td v-else class="text-xs-center">NO</td>
                  <td v-if="props.item.propietario" class="text-xs-center">SI</td>
                  <td v-else class="text-xs-center">NO</td>
                  <td v-if="props.item.propietario_residente" class="text-xs-center">SI</td>
                  <td v-else class="text-xs-center">NO</td>
                  <td v-if="props.item.residente_inquilino" class="text-xs-center">SI</td>
                  <td v-else class="text-xs-center">NO</td>
                  <td v-if="props.item.residente.censado" class="text-xs-left">{{ props.item.residente.censado_fecha }}</td>
                  <td v-else class="text-xs-left"></td>
                  <td class="text-xs-center">
                    <v-icon small class="mr-3"
                            @click="show_resident_info(props.item.residente_id)"
                            v-show="view_details_resident_btn === true"
                    >
                      visibility
                    </v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <!--
            <v-layout row wrap >
              <v-flex xs10 sm12 md12>
                Vehículos
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs10 sm12 md12>
                <v-data-table
                  :headers="vehiculo_detalles_headers"
                  v-bind:items="vivienda_info.vehiculos"
                >
                  <template v-slot:items="props">
                    <tr>
                      <td class="text-xs-left">{{ props.item.vehiculo.marca }}</td>
                      <td class="text-xs-left">{{ props.item.vehiculo.modelo }}</td>
                      <td class="text-xs-left">{{ props.item.vehiculo.anio }}</td>
                      <td class="text-xs-left">{{ props.item.vehiculo.color }}</td>
                      <td class="text-xs-left">{{ props.item.vehiculo.num_serie }}</td>
                      <td class="text-xs-left">{{ props.item.vehiculo.placas }}</td>
                      <td class="text-xs-left">{{ props.item.vehiculo.validez }}</td>
                      <td class="text-xs-left">
                        <v-btn flat icon @click.stop="carousel_dialog = true"
                               :disabled="Object.keys(props.item.vehiculo.fotos).length === 0"
                        >
                          <v-icon>collections</v-icon>
                        </v-btn>
                        <div class="text-xs-center">
                          <v-dialog
                            v-model="carousel_dialog"
                            max-width="900"
                          >
                            <v-card>
                              <v-toolbar dark color="primary">
                                <v-spacer></v-spacer>
                                <v-btn dark icon @click="carousel_dialog = false">
                                  <v-icon>close</v-icon>
                                </v-btn>
                              </v-toolbar>
                              <template>
                                <v-carousel dark hide-delimiters height="600" :cycle="false"
                                >
                                  <v-carousel-item
                                    v-for="(item,i) in props.item.vehiculo.fotos"
                                    :key="i"
                                  >
                                    <img :src="decode_base64(item.image)"
                                         style="height: 600px; display: block; margin: 0px auto;"
                                    />
                                  </v-carousel-item>
                                </v-carousel>
                              </template>
                            </v-card>
                          </v-dialog>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            -->
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import ApiService from '../common/api.service';
import { getJWTData } from '../common/jwt.service';

export default {
  data: () => ({
    timer: '',
    delete_vehicle: null,
    delete_resident: null,
    delete_vivienda: null,
    confirm_dialog: false,
    confirm_dialog_vehicle: false,
    confirm_deleted_dialog: false,
    puedeAutorizar: false,
    residente: null,
    residentValid: true,
    tipoResidente: null,
    residenteIsLoading: false,
    residenteSearch: null,
    residentesApiResult: [],
    search: null,
    presearch: null,
    infodialog: false,
    add_dialog: false,
    searchTimer: null,
    selected_desarrollo: null,
    selected_desarrollo_id: null,
    selected_subcondominio: null,
    desarrollo: null,
    subcondominio: null,
    subcondominio_id: null,
    n_vivienda: null,
    telefono: null,
    cajones_estacionamiento: null,
    num_tags: null,
    num_vehiculos: null,
    tipos_status_inmobiliaria: ['CONSTRUIDA', 'EN CONSTRUCCIÓN', 'LOTE', 'EN REMODELACIÓN', 'EN APROBACIÓN'],
    tipos_status: ['HABITADA', 'DESHABITADA', 'RENTADA'],
    selected_status: null,
    selected_inmobiliaria_status: null,
    close_resident_info: false,
    residentes_asociados: [],
    editing: false,
    carousel_dialog: false,
    editing_btn: false,
    delete_btn: false,
    remove_resident_btn: false,
    view_details_resident_btn: false,
    editing_details_btn: false,
    user_login_role: '',
    items: [],
    headers: [
      {
        text: 'Condominio', value: 'desarrollo', sortable: true,
      },
      {
        text: 'Sub-Condominio', value: 'subcondominio', sortable: true,
      },
      {
        text: 'Vivienda', value: 'n_vivienda', sortable: true,
      },
      {
        text: 'Estatus', value: 'status', sortable: true,
      },
      {
        text: 'Estatus Inmobiliaria', value: 'status_inmobiliaria', sortable: true,
      },
      {
        text: 'Teléfono', value: 'telefono', sortable: false,
      },
      {
        text: 'Cajones Estacionamiento', value: 'cajones_estacionamiento', sortable: false,
      },
      {
        text: 'Número De Tags', value: 'num_tags', sortable: false,
      },
      {
        text: 'Número De Vehículos', value: 'num_vehiculos', sortable: false,
      },
      {
        text: 'Acciones', value: 'acciones', sortable: false,
      },
    ],
    residente_headers: [
      {
        text: 'Nombre(s)', value: 'residente.nombres', sortable: true, class: 'px-2',
      },
      {
        text: 'Apellido Paterno', value: 'residente.apellido_paterno', sortable: true, class: 'px-2',
      },
      {
        text: 'Apellido Materno', value: 'residente.apellido_materno', sortable: true, class: 'px-2',
      },
      {
        text: 'NDS', value: 'residente.nds', sortable: true, class: 'px-2',
      },
      {
        text: 'Correo Electrónico', value: 'residente.email', sortable: true, class: 'px-2',
      },
      {
        text: 'Estatus', value: 'residente.status', sortable: true, class: 'px-2',
      },
      {
        text: 'Puede Autorizar', value: 'puede_autorizar', sortable: true, class: 'px-0',
      },
      {
        text: 'Propietario', value: 'propietario', sortable: true, class: 'px-0',
      },
      {
        text: 'Propietario Residente', value: 'propietario_residente', sortable: true, class: 'px-0',
      },
      {
        text: 'Residente Inquilino', value: 'residente_inquilino', sortable: true, class: 'px-0',
      },
      {
        text: 'Censado', value: 'censado_fecha', sortable: true, width: '120px', class: 'px-2',
      },
      {
        text: 'Acciones', value: 'acciones', sortable: false, class: 'px-0',
      },
    ],
    residente_detalles_headers: [
      {
        text: 'Nombre(s)', value: 'residente.nombres', sortable: true, class: 'px-2',
      },
      {
        text: 'Apellido Paterno', value: 'residente.apellido_paterno', sortable: true, class: 'px-2',
      },
      {
        text: 'Apellido Materno', value: 'residente.apellido_materno', sortable: true, class: 'px-2',
      },
      {
        text: 'NDS', value: 'residente.nds', sortable: true, class: 'px-2',
      },
      {
        text: 'Correo Electrónico', value: 'residente.email', sortable: true, class: 'px-2',
      },
      {
        text: 'Estatus', value: 'residente.status', sortable: true, class: 'px-2',
      },
      {
        text: 'Puede Autorizar', value: 'puede_autorizar', sortable: true, class: 'px-0',
      },
      {
        text: 'Propietario', value: 'propietario', sortable: true, class: 'px-0',
      },
      {
        text: 'Propietario Residente', value: 'propietario_residente', sortable: true, class: 'px-0',
      },
      {
        text: 'Residente Inquilino', value: 'residente_inquilino', sortable: true, class: 'px-0',
      },
      {
        text: 'Censado', value: 'censado_fecha', sortable: true, width: '120px', class: 'px-2',
      },
    ],
    vehiculo_headers: [
      {
        text: 'Marca', value: 'vehiculo.marca', sortable: true, class: 'px-2',
      },
      {
        text: 'Modelo', value: 'vehiculo.modelo', sortable: true, class: 'px-2',
      },
      {
        text: 'Año', value: 'vehiculo.anio', sortable: true, width: '90px', class: 'px-2',
      },
      {
        text: 'Color', value: 'vehiculo.color', sortable: true, class: 'px-2',
      },
      {
        text: 'Núm. Serie', value: 'vehiculo.num_serie', sortable: true, class: 'px-2',
      },
      {
        text: 'Placas', value: 'vehiculo.placas', sortable: true, width: '120px', class: 'px-2',
      },
      {
        text: 'Período de Validez', value: 'vehiculo.validez', sortable: true, class: 'px-2',
      },
      {
        text: 'Fotos', value: 'items', sortable: false, width: '100px', class: 'px-2',
      },
      {
        text: 'Acciones', value: 'acciones', sortable: false, width: '60px', class: 'px-0',
      },
    ],
    vehiculo_detalles_headers: [
      {
        text: 'Marca', value: 'vehiculo.marca', sortable: true, class: 'px-2',
      },
      {
        text: 'Modelo', value: 'vehiculo.modelo', sortable: true, class: 'px-2',
      },
      {
        text: 'Año', value: 'vehiculo.anio', sortable: true, width: '90px', class: 'px-2',
      },
      {
        text: 'Color', value: 'vehiculo.color', sortable: true, class: 'px-2',
      },
      {
        text: 'Núm. Serie', value: 'vehiculo.num_serie', sortable: true, class: 'px-2',
      },
      {
        text: 'Placas', value: 'vehiculo.placas', sortable: true, width: '120px', class: 'px-2',
      },
      {
        text: 'Período de Validez', value: 'vehiculo.validez', sortable: true, class: 'px-2',
      },
      {
        text: 'Fotos', value: 'items', sortable: false, width: '100px', class: 'px-2',
      },
    ],
    telefonos_headers: [
      {
        text: 'Teléfono', value: 'telefono', sortable: true,
      },
      {
        text: 'Tipo', value: 'tipo', sortable: true,
      },
      {
        text: 'Nombre Completo', value: 'nombre', sortable: true,
      },
    ],
    email_headers: [
      {
        text: 'Correo Electrónico', value: 'email', sortable: true,
      },
      {
        text: 'Tipo', value: 'tipo', sortable: true,
      },
    ],
    viviendas_headers: [
      {
        text: 'Condominio', value: 'vivienda.desarrollo', sortable: true,
      },
      {
        text: 'Subcondominio', value: 'vivienda.subcondominio', sortable: true,
      },
      {
        text: 'Vivienda', value: 'vivienda.n_vivienda', sortable: true,
      },
      {
        text: 'Teléfono', value: 'vivienda.telefono', sortable: true,
      },
      {
        text: 'Estatus', value: 'vivienda.status', sortable: true,
      },
      {
        text: 'Puede Autorizar', value: 'puede_autorizar', sortable: true,
      },
      {
        text: 'Propietario', value: 'propietario', sortable: true,
      },
      {
        text: 'Propietario Residente', value: 'propietario_residente', sortable: true,
      },
      {
        text: 'Residente Inquilino', value: 'residente_inquilino', sortable: true,
      },
    ],
    contactos_emergencia_headers: [
      {
        text: 'Nombre Completo', value: 'nombre_emergencia', sortable: true,
      },
      {
        text: 'Correo Electrónico', value: 'email_emergencia', sortable: true,
      },
      {
        text: 'Teléfono', value: 'telefono_emergencia', sortable: true,
      },
    ],
    vehiculo_pagination: {
      sortBy: 'vehiculo.validez',
    },
    valid: true,
    status_residente: null,
    dialog: false,
    text_required_rules: [
      v => !!v || 'Requerido',
    ],
    max_11_rule: [
      v => (v && v.length <= 20) || '\'Debe ser menos de  12 caracteres',
    ],
    nameRules: [
      v => !!v || 'Nombre es requerido',
    ],
    apellidoRules: [
      v => !!v || 'Apellido es requerido',
    ],
  }),
  computed: {
    formTitle() {
      return this.editing === false ? 'Agregar Vivienda' : 'Editar Vivienda';
    },
    residentes() {
      return this.residentesApiResult;
    },
    viviendas() {
      return this.$store.getters['capturaViviendas/viviendas_list'];
    },
    desarrollos() {
      return this.$store.getters['capturaViviendas/desarrollos_list'];
    },
    subcondominios() {
      return this.$store.getters['capturaViviendas/subcondominios_list'];
    },
    is_loading() {
      return this.$store.getters['capturaViviendas/is_loading_viviendas'];
    },
    vivienda_submited() {
      return this.$store.getters['capturaViviendas/vivienda_submited'];
    },
    alertType() {
      return this.$store.getters['capturaViviendas/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['capturaViviendas/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['capturaViviendas/alertContainer'];
    },
    asoc_submited() {
      return this.$store.getters['capturaViviendas/submited_resident_asoc'];
    },
    vivienda_info() {
      return this.$store.getters['capturaViviendas/vivienda_info'];
    },
  },
  watch: {
    vivienda_info(val) {
      if (this.editing) {
        if (typeof val.vivienda_id !== 'undefined') {
          // console.log(val);
          this.init_edit_data(val);
        }
      }
    },
    asoc_submited() {
      if (this.asoc_submited) {
        this.$refs.residentForm.resetValidation();
        this.close_resident_form();
        this.tipoResidente = null;
        this.puedeAutorizar = false;
        this.residente = null;
      }
    },
    tipoResidente(val) {
      if (val === 'propietario') {
        this.puedeAutorizar = false;
      } else {
        this.puedeAutorizar = true;
      }
    },
    residenteSearch() {
      // Items have already been loaded
      if (this.residentes.length > 0) return;
      // Items have already been requested
      if (this.residenteIsLoading) return;
      this.residenteIsLoading = true;
      ApiService.setHeader();
      ApiService.query('accesos/residentes')
        .then(({ data }) => {
          this.residentesApiResult = data.residentes;
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.residenteIsLoading = false;
        });
    },
    vivienda_submited(val) {
      if (val) {
        // this.$refs.residentForm.reset();
        // this.close_resident_form();
        this.$refs.form.reset();
        this.close_dialog();
      }
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
    selected_subcondominio(val) {
      this.selected_desarrollo = val.desarrollo;
      this.selected_desarrollo_id = val.desarrollo_id;
      this.subcondominio_id = val.id;
    },
  },
  methods: {
    init_edit_data(data) {
      this.vivienda_id = data.vivienda_id;
      this.desarrollo = data.desarrollo;
      this.subcondominio = data.subcondominio;
      this.n_vivienda = data.n_vivienda;
      this.telefono = data.telefono;
      this.cajones_estacionamiento = data.cajones_estacionamiento;
      this.num_tags = data.num_tags;
      this.num_vehiculos = data.num_vehiculos;
      this.selected_status = data.status;
      this.selected_inmobiliaria_status = data.status_inmobiliaria;
      this.residentes_asociados = [...data.residentes];
    },
    prepare_delete(vivienda, residente) {
      this.delete_resident = residente;
      this.delete_vivienda = vivienda;
      this.confirm_dialog = true;
    },
    cancel_delete() {
      this.delete_resident = null;
      this.delete_vivienda = null;
      this.confirm_dialog = false;
    },
    delete_asoc() {
      this.confirm_dialog = false;
      const data = { vivienda_id: this.delete_vivienda, residente_id: this.delete_resident };
      this.$store.dispatch('capturaViviendas/deleteAsocAction', data);
    },
    sendig_asoc() {
      return this.$store.getters['capturaViviendas/submiting_resident_asoc'];
    },
    prepare_delete_vehicle(vivienda, vehiculo) {
      this.delete_vehicle = vehiculo;
      this.delete_vivienda = vivienda;
      this.confirm_dialog_vehicle = true;
    },
    cancel_delete_vehicle() {
      this.delete_vehicle = null;
      this.delete_vivienda = null;
      this.confirm_dialog_vehicle = false;
    },
    delete_asoc_vehicle() {
      const data = { vivienda_id: this.delete_vivienda, vehiculo_id: this.delete_vehicle };
      this.$store.dispatch('capturaViviendas/deleteAsocVehicleAction', data);
      this.confirm_dialog_vehicle = false;
    },
    show_delete_vivienda_dialog(vivienda) {
      this.$store.dispatch('capturaViviendas/fetchViviendaInfo', vivienda);
      this.confirm_deleted_dialog = true;
    },
    delete_vivienda_confirm() {
      this.confirm_deleted_dialog = false;
      this.$store.dispatch('capturaViviendas/deleteVivienda', this.vivienda_info.vivienda_id);
    },
    show_vivienda_info(vivienda) {
      this.$store.dispatch('capturaViviendas/fetchViviendaInfo', vivienda);
      this.infodialog = true;
    },
    show_resident_info(residente) {
      this.$store.dispatch('capturaResidentes/fetchResidentInfo', residente);
      this.close_resident_info = true;
    },
    resident_info() {
      return this.$store.getters['capturaResidentes/resident_info'];
    },
    edit_vivienda_info(vivienda) {
      // console.log(vivienda);
      this.editing = true;
      this.$store.dispatch('capturaViviendas/fetchViviendaInfo', vivienda);
      this.dialog = true;
    },
    close_resident_form() {
      this.add_dialog = false;
    },
    close_info_dialog() {
      this.infodialog = false;
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    close_dialog() {
      this.dialog = false;
    },
    clear_null(value) {
      if (value === null) {
        return '';
      }
      return value;
    },
    send_form() {
      if (this.$refs.form.validate()) {
        const formdata = new FormData();
        formdata.set('n_vivienda', this.clear_null(this.n_vivienda));
        formdata.set('telefono', this.clear_null(this.telefono));
        formdata.set('cajones_estacionamiento', this.clear_null(this.cajones_estacionamiento));
        formdata.set('num_tags', this.clear_null(this.num_tags));
        formdata.set('num_vehiculos', this.clear_null(this.num_vehiculos));
        formdata.set('status', this.clear_null(this.selected_status));
        formdata.set('status_inmobiliaria', this.clear_null(this.selected_inmobiliaria_status));
        // formdata.set('residentes', JSON.stringify(this.residentes));
        if (this.editing) {
          formdata.set('vivienda_id', this.vivienda_info.vivienda_id);
        } else {
          formdata.set('subcondominio_id', this.clear_null(this.subcondominio_id));
        }
        this.$store.commit('capturaViviendas/resetViviendaSubmit');
        this.$store.dispatch('capturaViviendas/sendVivienda', formdata);
      }
    },
    send_resident_form() {
      if (this.$refs.residentForm.validate()) {
        let propietario = false;
        let residente = false;
        let inquilino = false;
        if (this.tipoResidente === 'propietario') {
          residente = false;
          inquilino = false;
          propietario = true;
        }
        if (this.tipoResidente === 'propietario_residente') {
          residente = true;
          inquilino = false;
          propietario = false;
        }
        if (this.tipoResidente === 'residente_inquilino') {
          residente = false;
          inquilino = true;
          propietario = false;
        }
        const formdata = {
          vivienda_id: this.$store.getters['capturaViviendas/vivienda_info'].vivienda_id,
          residente_id: this.residente.id,
          puede_autorizar: this.puedeAutorizar,
          propietario,
          propietario_residente: residente,
          residente_inquilino: inquilino,
        };
        this.$store.commit('capturaViviendas/resetViviendaSubmit');
        this.$store.dispatch('capturaViviendas/asociateResident', formdata);
      }
    },
    fetchViviendasList() {
      if (!this.$store.getters['capturaViviendas/is_loading_viviendas']) {
        this.$store.dispatch('capturaViviendas/clearViviendasAction');
        this.$store.dispatch('capturaViviendas/fetchViviendas');
        this.$store.dispatch('capturaViviendas/fetchDesarrollos');
        this.$store.dispatch('capturaViviendas/fetchSubcondominios');
      }
    },
    cancelAutoUpdate() { clearInterval(this.timer); },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    decode_base64(encoded) {
      const src = `data:image/png;base64,${encoded}`;
      return src;
    },
  },
  created() {
    if (!(this.$store.getters['capturaViviendas/viviendas_list'].length > 0)) {
      this.fetchViviendasList();
    } else {
      this.$store.commit('capturaViviendas/fetchedViviendas');
    }
    this.user_login_role = getJWTData().user_claims.role;
    if (['jefe_monitoristas', 'censo', 'admin', 'monitoristas', 'atencion_residentes', 'avisos'].includes(this.user_login_role)) {
      if (this.user_login_role === 'admin') {
        this.editing_btn = true;
        this.editing_details_btn = true;
        // this.delete_btn = true;
      } else if (this.user_login_role === 'censo' || this.user_login_role === 'jefe_monitoristas') {
        this.editing_btn = true;
        this.editing_details_btn = true;
        this.remove_resident_btn = true;
      }
      this.view_details_resident_btn = true;
    }
  },
  beforeDestroy() {
    this.cancelSearchTimer();
  },
};
</script>
<style>
  .v-carousel__prev .v-btn,
  .v-carousel__next .v-btn {
    color: rgba(0, 0, 0, .1);
  }
</style>
